// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./vollDammCup.jpg')
const allTwoEs = require('./static-1.jpg')
const allTwoCa = require('./static-1.jpg')
const allFourEs = require('./static-1.jpg')
const allFourCa = require('./static-1.jpg')
const catalogTwoEs = require('./static-1.jpg')
const catalogTwoCa = require('./static-1.jpg')
const catalogFourEs = require('./static-1.jpg')
const catalogFourCa = require('./static-1.jpg')

const model = creativityMediaModel({
  catalogID: 'glassware',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
